// This file was auto-generated by Fern from our API Definition.
const FileUploadBodyPropertyEncodingValues = {
    Exploded: "exploded",
    Json: "json",
    Form: "form",
};
export const FileUploadBodyPropertyEncoding = Object.assign(Object.assign({}, FileUploadBodyPropertyEncodingValues), { _visit: (value, visitor) => {
        switch (value) {
            case FileUploadBodyPropertyEncoding.Exploded:
                return visitor.exploded();
            case FileUploadBodyPropertyEncoding.Json:
                return visitor.json();
            case FileUploadBodyPropertyEncoding.Form:
                return visitor.form();
            default:
                return visitor._other();
        }
    } });
